// Theme Colors
// Initially this will be blank. Later on when app is initialized we will assign bootstrap colors to this from CSS variables.
import logo from './logo_eds_2.svg'

export const $themeColors = {}

// App Breakpoints
// Initially this will be blank. Later on when app is initialized we will assign bootstrap breakpoints to this object from CSS variables.
export const $themeBreakpoints = {}

function getPerPage() {
    const perPage = import.meta.env.VITE_APP_UI_SETTINGS_PER_PAGE
    if (!perPage) {
        return 10
    }
    return Number(perPage)
}

function getPerPageOptions() {
    const perPageOptions = import.meta.env.VITE_APP_UI_SETTINGS_PER_PAGE_OPTIONS
    if (!perPageOptions) {
        return [10, 20, 50, 100]
    }
    return perPageOptions.split(',').map(x => Number(x))
}

function isCurrentDateFilter() {
    const settingsFilterDef = import.meta.env
        .VITE_APP_UI_SETTINGS_FILTER_DEFAULT
    if (!settingsFilterDef) {
        return false
    }
    return settingsFilterDef.includes('is_current_date')
}

function getAvailableListOrder() {
    const settingsListOrder = import.meta.env.VITE_APP_UI_SETTINGS_VIEWS
    if (!settingsListOrder) {
        return ['default']
    }
    return settingsListOrder.split(',')
}

function getViewListMenu() {
    return ['default', 'compact']
}

function getSortListMenu() {
    return ['price', 'name']
}

function getAvailableTimers() {
    const timers = import.meta.env.VITE_APP_UI_SETTINGS_TIMER
    if (!timers) {
        return [0]
    }
    return timers.split(',').map(x => Number(x))
}

function getShowStartButton() {
    // return import.meta.env.VITE_APP_UI_SETTINGS_SHOW_START_BUTTON === 'show'
    return true
}

function isChangeOperator() {
    return import.meta.env.VITE_APP_UI_SETTINGS_CHANGE_OPERATOR === 'change'
}

function isRefreshDish() {
    return import.meta.env.VITE_APP_UI_SETTINGS_REFRESH_DISH === 'refresh'
}

// APP CONFIG
export const $themeConfig = {
    app: {
        appName: '',
        naumenWs: import.meta.env.VITE_APP_API_NAIMEN,
        backUrl: `${import.meta.env.VITE_APP_API_URL_BACK}/v1`,
        backUrlDivisions: `${import.meta.env.VITE_APP_API_DIVISIONS}/v1`,
        backUrlDeliveryWorker: `${
            import.meta.env.VITE_APP_API_URL_DELIVERY_WORKER
        }/v1`,
        backUrlDeliveryApiV1: `${import.meta.env.VITE_APP_API_URL_DELIVERY}/v1`,
        backUrlDeliveryApiV2: `${import.meta.env.VITE_APP_API_URL_DELIVERY}/v2`,
        backUrlSectors: `${
            import.meta.env.VITE_APP_API_URL_LOGISTIAN_SECTORS
        }/v1`,
        gqlUrl: `${import.meta.env.VITE_APP_API_URL_BACK}/graphql`,
        geocoderUrl: `${import.meta.env.VITE_APP_API_GEOCODER}/api/v1`,
        backUrlAuth: import.meta.env.VITE_APP_API_URL_BACK,
        urlImageProxy: import.meta.env.VITE_APP_API_URL_IMAGE,
        appLogoImage: logo,
        courierUrl: import.meta.env.VITE_APP_API_COURIERS,
        n8nWebhookUrl: `${import.meta.env.VITE_APP_API_URL_BACK}/n8n`,
        n8nWebhookUrlSource: `${import.meta.env.VITE_APP_API_URL}/`,
        centrifugoWsUrl: import.meta.env.VITE_APP_CENTRIFUGO_URL,
        menuUrl: `${import.meta.env.VITE_APP_API_MENU}/v1`,
    },
    ui: {
        showButtonStart: getShowStartButton(),
    },
    settings: {
        isChangeOperator: isChangeOperator(),
        isRefreshDish: isRefreshDish(),
    },
    layout: {
        isRTL: false,
        skin: 'bordered', // light, dark, bordered, semi-dark
        routerTransition: 'fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
        type: 'horizontal', // vertical, horizontal
        contentWidth: 'full', // full, boxed
        menu: {
            hidden: true,
            isCollapsed: false,
        },
        navbar: {
            // ? For horizontal menu, navbar type will work for navMenu type
            type: 'sticky', // static , sticky , floating, hidden
            backgroundColor: '', // BS color options [primary, success, etc]
        },
        footer: {
            type: 'hidden', // static, sticky, hidden
        },
        customizer: true,
        enableScrollToTop: true,
        availableListOrder: getAvailableListOrder(),
        availableTimers: getAvailableTimers(),
        perPage: getPerPage(),
        perPageOptions: getPerPageOptions(),
        isCurrentDateFilter: isCurrentDateFilter(),
    },
    menu: {
        listMenu: getViewListMenu(),
        sortListMenu: getSortListMenu(),
    },
}
